import { Controller, UseFormReturn } from "react-hook-form";
import { Label } from "@/modern/components/ui/label";
import { Textarea } from "@/modern/components/ui/textarea";
import { FileFormData } from "../hooks/useFileDetailForm";

interface FileDescriptionSectionProps {
  form: UseFormReturn<FileFormData>;
  canEditFile: boolean;
  isCCImage: boolean;
}

/**
 * File description section
 */
export const FileDescriptionSection = ({ form, canEditFile, isCCImage }: FileDescriptionSectionProps) => {
  const descriptionPlaceholder = isCCImage ? "Description is provided by CompanyCam" : "Add helpful context for this file";

  return (
    <section className="space-y-2">
      <Label htmlFor="description" className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">
        Description
      </Label>
      <Controller
        name="description"
        control={form.control}
        render={({ field }) => (
          <Textarea
            id="description"
            value={field.value ?? ""}
            onChange={(event) => field.onChange(event.target.value)}
            placeholder={descriptionPlaceholder}
            readOnly={!canEditFile}
            className="min-h-[120px] resize-none"
          />
        )}
      />
    </section>
  );
};
